"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.StaffIcon = (0, react_1.forwardRef)(function StaffIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.83387 8.93273C7.83387 12.0466 9.56415 14.7186 11.9966 14.7186C14.428 14.7186 16.1561 12.0466 16.1561 8.93273C16.1561 5.81997 14.6817 4 11.9966 4C9.31041 4 7.83387 5.81997 7.83387 8.93273ZM5.24719 20.6193C6.14405 21.2066 8.39605 21.4997 11.9999 21.4997C15.6037 21.4997 17.8546 21.2066 18.7526 20.6204C18.834 20.5671 18.8997 20.4931 18.9429 20.406C18.9862 20.3189 19.0054 20.2219 18.9987 20.1249C18.8324 17.6881 16.4973 16.4685 11.9955 16.4685C7.49263 16.4685 5.16079 17.6881 5.0011 20.1271C4.99497 20.2235 5.01451 20.3199 5.05773 20.4064C5.10096 20.4928 5.16634 20.5663 5.24719 20.6193Z", fill: "currentColor" })));
});
